import { getApiData, getNewApiData } from "../utils/APIHelper";

const SCHEDULE_ENDPOINTS = {
  GET_PROJECT_ACTIVITIES: (projectId) => `api/project/${projectId}/activities`,
  CREATE_SCOPE: (projectId) => `api/project/${projectId}/scope`,
  UPDATE_SCOPE: (scopeId) => `api/project/scope/${scopeId}`,
  GET_SCOPE_DETAILS: (scopeId) => `api/project/scope/${scopeId}/boqs`,
  GET_PROJECT_ROOM_BOQS: (projectId) => `api/project/${projectId}/rooms/boqs`,
  GET_PROJECT_SCOPES: (projectId) => `api/project/${projectId}/scopes?scope_filter=CONTRACTED`,
  GET_ACTIVITY_DEPENDENCIES: (projectId) => `api/project/${projectId}/activity-dependecies`,
  CREATE_ACTIVITY: (scopeId) => `api/scope/${scopeId}/activity`,
  DELETE_ACTIVITY: (activityId) => `api/project/activity/${activityId}`,
  GET_SCOPE_BILLING_MILESTONES: (scopeId) => `api/scope/${scopeId}/billing-milestone`,
};

export const getProjectActivities = async (projectId) => {
  try {
    const response = await getApiData(
      SCHEDULE_ENDPOINTS.GET_PROJECT_ACTIVITIES(projectId),
      "GET",
      {}
    );
    return response;
  } catch (error) {
    console.error("Error fetching project activities:", error);
    throw error;
  }
};

// export const createScope = async (projectId, scopeData) => {
//   try {
//     const response = await getApiData(
//       SCOPE_ENDPOINTS.CREATE_SCOPE(projectId),
//       "POST",
//       scopeData
//     );
//     return response;
//   } catch (error) {
//     console.error("Error creating scope:", error);
//     throw error;
//   }
// };

// export const getScopeDetails = async (scopeId) => {
//   try {
//     const response = await getApiData(
//       SCOPE_ENDPOINTS.GET_SCOPE_DETAILS(scopeId),
//       "GET",
//       {}
//     );
//     return response;
//   } catch (error) {
//     console.error("Error fetching scope details:", error);
//     throw error;
//   }
// };

/**
 * Get all scopes for a project
 * @param {string} projectId - Project ID
 * @returns {Promise} API response
 */
export const getProjectScopes = async (projectId) => {
  try {
    const response = await getApiData(
      SCHEDULE_ENDPOINTS.GET_PROJECT_SCOPES(projectId),
      "GET",
      {}
    );
    return response;
  } catch (error) {
    console.error("Error fetching project scopes:", error);
    throw error;
  }
};

/**
 * Get activity dependencies for a project
 * @param {string} projectId - Project ID
 * @returns {Promise} API response
 */
export const getActivityDependencies = async (projectId, scopeId = null) => {
  try {
    let endpoint = SCHEDULE_ENDPOINTS.GET_ACTIVITY_DEPENDENCIES(projectId);
    if (scopeId) {
      endpoint = `${endpoint}?scope_id=${scopeId}`;
    }
    const response = await getApiData(
      endpoint,
      "GET",
      {}
    );
    return response;
  } catch (error) {
    console.error("Error fetching activity dependencies:", error);
    throw error;
  }
};

/**
 * Create a new activity for a scope
 * @param {string} scopeId - Scope ID
 * @param {Object} activityData - Activity data
 * @returns {Promise} API response
 */
export const createActivity = async (scopeId, activityData) => {
  try {
    const response = await getNewApiData(
      SCHEDULE_ENDPOINTS.CREATE_ACTIVITY(scopeId),
      "POST",
      activityData,
      { "Content-Type": "application/json" },
      true
    );
    return response;
  } catch (error) {
    console.error("Error creating activity:", error);
    throw error;
  }
};

/**
 * Delete an activity by id
 * @param {string|number} activityId - Activity ID
 * @returns {Promise} API response
 */
export const deleteActivity = async (activityId) => {
  try {
    const response = await getApiData(
      SCHEDULE_ENDPOINTS.DELETE_ACTIVITY(activityId),
      "DELETE",
      {}
    );
    return response;
  } catch (error) {
    console.error("Error deleting activity:", error);
    throw error;
  }
};

/**
 * Get billing milestones for a scope
 * @param {string} scopeId - Scope ID
 * @returns {Promise} API response
 */
export const getScopeBillingMilestones = async (scopeId) => {
  try {
    const response = await getApiData(
      SCHEDULE_ENDPOINTS.GET_SCOPE_BILLING_MILESTONES(scopeId),
      "GET",
      {}
    );
    return response;
  } catch (error) {
    console.error("Error fetching scope billing milestones:", error);
    throw error;
  }
};
